import React from 'react';

export const CustomizationPage = () => {
    return <div>CustomizationPage</div>;
};
